import { DataLayer } from "@sazka/utils/data-layer";
import { CasinoGameType } from "../model/casino-game-type";

/**
 * Pushes game open event to datalayer,
 * @param type Type of game - scrapper or game
 * @param analyticsGameCode analytics game code from CMS
 * @param moneyMode flag if games is played for money or in demo mode
 */
export const analyticsCasinoGameDetail = (
    type: CasinoGameType,
    analyticsGameCode: string,
    moneyMode: boolean,
    gameId: number,
    manufacturer: string = null,
    placement: string = null,
    position = 0,
    ngGameDefinition: any = null
): void => {
    const gameTypeMapping = {
        [CasinoGameType.game]: "hry",
        [CasinoGameType.eticket]: "elosy",
        [CasinoGameType.livedealer]: "hry-live",
        [CasinoGameType.funpark]: "funpark",
        [CasinoGameType.underground]: "stiraci-hry",
    };
    const currentUrl = window.location.href.toLowerCase();
    const effectiveType = currentUrl.includes("stiraci-hry") ? CasinoGameType.underground : type;

    const gameType = gameTypeMapping[effectiveType] || "";

    const page = {
        type: "game.detail",
        verticalCode: gameType,
        verticalCodeStrict: gameType,
        gameCode: analyticsGameCode,
        gameCodeStrict: analyticsGameCode,
        gameMode: moneyMode ? "money" : "fun",
        gameid: gameId,
    };

    if (type == CasinoGameType.eticket && ngGameDefinition) {
        page["externalGameProvider"] = ngGameDefinition.externalGameProvider;
        page["externalGameSubProvider"] = ngGameDefinition.externalGameSubProvider;
    }

    if (type !== CasinoGameType.eticket) {
        if (manufacturer) {
            page["supplier"] = manufacturer;
        } else if (ngGameDefinition) {
            page["supplier"] = ngGameDefinition?.externalGameSubProvider || ngGameDefinition?.externalGameProvider;
        }
    }

    if (placement) {
        page["placement"] = placement;
        page["position"] = position;
    }

    DataLayer.push({
        page: page,
        event: "page",
    });
};

/**
 * Pushes deposit button click to datalayer
 */
export const analyticsCasinoDepositClick = (): void => {
    DataLayer.push({
        event: "action.click.hry",
        action: {
            click: {
                type: "inGameDeposit",
            },
        },
    });
};

/**
 * Pushes analytics money mode toggle click to datalayer
 */
export const analyticsCasinoToggleMoneyMode = (playForMoney: boolean): void => {
    DataLayer.push({
        event: "action.click.hry",
        action: {
            click: {
                type: playForMoney ? "money" : "fun",
            },
        },
    });
};
